import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Form, Tabs } from 'antd';
import {
  Button,
  Input,
  Layout,
  Select,
  Phone,
  MessageSteps,
  Footer,
} from 'components';


import LetterIcon from 'assests/icons/letter.icon';
import AudienceIcon from 'assests/icons/audience.icon';
import ProfileIcon from 'assests/icons/profile.icon';
import ClockIcon from 'assests/icons/clock.icon';

import { ChooseTitle, Receivers, TextMessage } from 'pages';
import DeliveryTime from './message-steps/delivery-time';
import { useLocation } from 'react-router';

import { JobProvider, useJob } from 'context/job.context';


const paymentSteps = [
  {
    text: 'Ünvan',
    icon: <ProfileIcon />,
  },
  {
    text: 'Mesaj',
    icon: <LetterIcon />,
  },
  {
    text: 'Alıcılar',
    icon: <AudienceIcon />,
  },
  {
    text: 'Gönderim zamanı',
    icon: <ClockIcon />,
  },
];

const MessageCreate = () => {
  
  let location = useLocation();
  const data = location.state;
  const [current,setCurrent] = useState(0);
  

  return (
    <JobProvider>
    <Layout
      customMenuRender={() => (
        <MessageSteps items={paymentSteps} current={current} status="process" />
      )}
    >
     {current==0 &&
          <ChooseTitle  
         
            updateCurrent={(current)=> setCurrent(current)} 
          ></ChooseTitle>
        }
        {current==1 && 
      
          <TextMessage  
        
            updateCurrent={(current)=> setCurrent(current)} 
          ></TextMessage>
      } {current==2 && 
      
        <Receivers  
      
          updateCurrent={(current)=> setCurrent(current)} 
        ></Receivers>
    } {current==3 && 
      
        <DeliveryTime  
                  updateCurrent={(current)=> setCurrent(current)} 
        ></DeliveryTime>
    }
           <Footer />
    </Layout>
    </JobProvider>

  );
};

export default MessageCreate;
